// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './resources/en';
import fi from './resources/fi';

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Bind i18next to React
  .init({
    resources: {en, fi},
    fallbackLng: 'en', // Default language if none detected
    interpolation: {
      escapeValue: false // React handles XSS by default
    }
  });

export default i18n;